import Vue from 'vue'
import App from './App.vue'
import router from './router'

import '@/assets/css/css2.css'
import '@/assets/css/cust.css'

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app') 